//      
import {ToastContainer, Zoom} from "react-toastify/unstyled";
import React from "react";
import "react-toastify/ReactToastify.css";
import "./ToastifyContainer.scss";

                                   

const ToastifyContainer = (props                    ) => {
	return (
		<ToastContainer
			id={"selekt-toastContainer"}
			className={"selekt-noPrint overlay"}
			autoClose={2700}
			closeButton={false}
			closeOnClick
			toastClassName="toastBody"
			hideProgressBar
			transition={Zoom}
		/>);
};

export default ToastifyContainer;
